import { httpV2 } from '@/bundles/Http/factory/httpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import AvailabilityIngestionService from '@/bundles/AvailabilityIngestion/services/AvailabilityIngestionService';

function availabilityIngestionServiceFactory () {
  return new AvailabilityIngestionService(httpV2, new ErrorMapper());
}

export const availabilityIngestionService = availabilityIngestionServiceFactory();
